import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSkeletonLoader,{attrs:{"type":"card-heading, image"}})
}
var staticRenderFns = []

export { render, staticRenderFns }